import styled from "styled-components";

export const ConversationContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: 10px;
  height: calc(100vh - 120px) !important;
  overflow-y: auto !important;
`;

export const MessagesContainer = styled.div`
  flex: 1;
  padding: 24px 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 15px;

  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.borderColor};
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 3px;
    &:hover {
      background: ${({ theme }) => theme.colors.primary};
      opacity: 0.8;
    }
  }
  &::-webkit-scrollbar-corner {
    background: ${({ theme }) => theme.colors.borderColor};
  }
`;

export const MessageBubble = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ isUser }) => (isUser ? "flex-end" : "flex-start")};
  max-width: 75%;
  margin-left: ${({ isUser }) => (isUser ? "auto" : "0")};
  margin-right: ${({ isUser }) => (isUser ? "0" : "auto")};
`;

export const MessageContent = styled.div`
  background: ${({ isUser, theme }) =>
    isUser ? theme.colors.primary : theme.colors.white};
  color: ${({ isUser, theme }) =>
    isUser ? theme.colors.white : theme.colors.secondary};
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  padding: 14px 18px;
  border-radius: 10px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  word-wrap: break-word;
  position: relative;

  ${({ isUser }) =>
    isUser &&
    `
    border-bottom-right-radius: 6px;
  `}

  ${({ isUser }) =>
    !isUser &&
    `
    border-bottom-left-radius: 6px;
  `}
`;

export const MessageTime = styled.span`
  float: right;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  /* color: ${({ theme }) => theme.colors.textColor}; */
  color: ${({ isUser }) =>
    isUser
      ? `${({ theme }) => theme.colors.textColor}`
      : `${({ theme }) => theme.colors.white}`};
  margin-left: ${({ isUser }) => (isUser ? "18px" : "18px")};
  margin-right: ${({ isUser }) => (isUser ? "18px" : "0")};
`;

export const InputContainer = styled.span`
  padding: 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.bodyBg};
`;

export const InputField = styled.textarea`
  width: 100%;
  background: ${({ theme }) => theme.colors.bodyBg};
  border: none;
  border-radius: 0px 0px 10px 10px;
  padding: 10px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.secondary};
  outline: none;
  transition: all 0.2s ease;
  resize: none;
  position: relative;
  height: 100%;
  &::placeholder {
    color: #999999;
    font-weight: 400;
  }
`;

export const InputControls = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  pointer-events: none;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const MagicWandIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  transition: all 0.2s ease;
  pointer-events: all;

  &:hover {
    opacity: 0.8;
    transform: scale(1.1);
  }

  svg {
    color: ${({ theme }) => theme.colors.primary};
    filter: ${({ theme }) => theme.colors.imgFilterColor};
  }
`;

export const SendButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: ${({ theme }) => theme.colors.white};
  pointer-events: all;

  &:hover {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  &:focus {
    outline: none;
  }

  svg {
    color: currentColor;
  }
`;
